import { createContext } from "use-context-selector"

import { createProvider } from "domain/createProvider"
import { getDataGridInitState } from "domain/utils"

const initState = getDataGridInitState()

export const ActivityLogContext = createContext(initState)

export const ActivityLogProvider = createProvider(ActivityLogContext, initState)
